import { BaseContainerModel } from '../base-container.model';
import { bl_hc_patient_hdr_RowClass, bl_hc_patient_hdr_RowInterface } from '../../dbschema/bl_hc_patient_hdr.model';


export class HcPatientHdrContainerModel extends BaseContainerModel {
  bl_hc_patient_hdr: bl_hc_patient_hdr_RowInterface = new bl_hc_patient_hdr_RowClass();
}